import * as Readmore from 'readmore-js';

global.Readmore = Readmore;
const readmore = new Readmore.default('.readmore-js', {
  moreLink: '<a href="#" class="readmore-link" id="readMoreMore">Mehr lesen</a>',
  lessLink: '<a href="#" class="readmore-link less" id="readMoreLess">Weniger lesen</a>',
  afterToggle(trigger, el, expanded) {
    if (!expanded) document.getElementById('intro').scrollIntoView({behavior: 'smooth'});
    el.classList.toggle('rmjs-shadow');
  }
});
